const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmAllSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6766"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.925-821.256 4.361-4.381-.788-.788-3.573 3.573-1.8-1.79-.788.808zM140-809.13v-1.9h14.545v1.9zm15.812-8.854a5.794 5.794 0 0 1-4.251-1.757 5.785 5.785 0 0 1-1.759-4.249 5.794 5.794 0 0 1 1.757-4.251 5.785 5.785 0 0 1 4.249-1.759 5.794 5.794 0 0 1 4.251 1.757 5.785 5.785 0 0 1 1.759 4.249 5.794 5.794 0 0 1-1.757 4.251 5.785 5.785 0 0 1-4.249 1.759zM140-819.249v-1.9h7.385a9.075 9.075 0 0 0 .39.994 6.117 6.117 0 0 0 .52.9zm0 5.059v-1.9h11.8a8.489 8.489 0 0 0 1.306.567 7.7 7.7 0 0 0 1.435.336v.995z",
    transform: "translate(-137 833)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157510",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmAllSelected);
export default __webpack_public_path__ + "static/media/confirm_all_selected.1b13642289b5011c7270d22ab8e6dc6f.svg";
export { ForwardRef as ReactComponent };